import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemTeaCup extends Item {
    constructor() {
        super(definitions.ITEM_ID.TEA_CUP, texture("prop_tea_cup"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 0.6, new PIXI.Point(0, 0));
    }
}